module.exports = __webpack_public_path__ + "img/Image - Header 5@2x(1).6db7ef28.png";